import { JournalColumnType } from "application/journal/types";
import { ProductsJournalController } from "../../journal/journal.controller";

export class OsagoJournalController extends ProductsJournalController {
    public columns: JournalColumnType[];
    public $onInit(): void {
        this.columns = [{
            defaultFilterOperation: "startswith",
            displayText: "Серия-номер полиса",
            inlineFilter: true,
            name: "PolicyNumber",
            pinned: true,
            renderer: (item) => item.PolicyFullValue,
            tooltipText: "Поиск только<br/>по номеру",
            type: "Edm.String",
        }, {
            defaultFilterOperation: "eq",
            displayText: "Статус договора",
            getVariants: () => this.getStatusVariants(),
            inlineFilter: true,
            name: "StatusName",
            pinned: true,
            requires: ["StatusName", "StatusId", "ContractStatusAdditionalInfo", "IsPaid"],
            template: `
                <span
                    ng-bind="item.StatusName"
                    ng-class="vm.getContractStatusLabelClass(item)">
                </span>
                <br/>
                <span ng-bind="item.ContractStatusAdditionalInfo" class="text-muted"></span>
            `,
            type: "Edm.String",
        }, {
            defaultFilterOperation: "eq",
            displayText: "Статус платежа",
            getVariants: () => this.getStatusPaymentVariants(),
            inlineFilter: true,
            name: "IsPaid",
            pinned: true,
            requires: ["IsPaid"],
            template: `
                <span
                    ng-bind="item.IsPaid ? 'Оплачен' : 'Не оплачен'"
                    ng-class="{'label-primary': item.IsPaid, 'label-danger': !item.IsPaid}">
                </span>
                <br/>
            `,
            type: "Edm.String",
        }, {
            displayText: "Доп. информация о статусе",
            name: "ContractStatusAdditionalInfo",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Срок страхования",
            name: "InsuranceTerm",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Начало срока страхования",
            name: "ContractFrom",
            ngFilter: this.dateFormatWithoutTimeZone,
            type: "Edm.DateTimeOffset",
            visible: false,
        }, {
            displayText: "Окончание срока страхования",
            name: "ContractTo",
            ngFilter: this.dateFormatWithoutTimeZone,
            type: "Edm.DateTimeOffset",
            visible: false,
        }, {
            displayText: "Количество водителей",
            name: "DriversCount",
            type: "Edm.Int32",
            visible: false,
        },
        {
            defaultFilterOperation: "eq",
            displayText: "Дата заключения договора",
            inlineFilter: true,
            name: "SigningDate",
            ngFilter: this.dateFormatWithoutTimeZone,
            pinned: true,
            type: "Edm.DateTimeOffset",
        }, {
            displayText: "Срок, Начало, Окончание",
            requires: ["InsuranceTerm", "ContractFrom", "ContractTo"],
            template: `
                <span ng-bind="item.InsuranceTerm"></span>
                <br/>
                <span ng-bind="item.ContractFrom | ${this.dateFormatWithoutTimeZone}"></span>
                <br/>
                <span ng-bind="item.ContractTo | ${this.dateFormatWithoutTimeZone}"></span>
            `,
            type: "Edm.String",
        }, {
            displayText: "Начало срока страхования",
            name: "ContractFrom",
            type: "Edm.DateTimeOffset",
            visible: false,
        }, {
            displayText: "Окончание срока страхования",
            name: "ContractTo",
            type: "Edm.DateTimeOffset",
            visible: false,
        }, {
            displayText: "",
            name: "",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Страховая премия",
            inlineFilter: true,
            name: "InsurancePremium",
            ngFilter: "thousand",
            type: "Edm.Decimal",
        }, {
            defaultFilterOperation: "startswith",
            displayText: "Страхователь",
            inlineFilter: true,
            name: "InsuredName",
            pinned: true,
            type: "Edm.String",
        }, {
            defaultFilterOperation: "startswith",
            displayText: "Филиал",
            inlineFilter: true,
            name: "EmployeeFilialName",
            pinned: true,
            type: "Edm.String",
        }, {
            defaultFilterOperation: "startswith",
            displayText: "Канал продаж",
            inlineFilter: true,
            name: "SaleChannel",
            pinned: true,
            type: "Edm.String",
        }, {
            defaultFilterOperation: "startswith",
            displayText: "Подразделение",
            inlineFilter: true,
            name: "EmployeeSubdivisionName",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Комментарий продавца",
            name: "SellerComment",
            type: "Edm.String",
        }, {
            displayText: "Модель, Год, VIN, Гос.Номер",
            inlineFilter: "VehicleLicensePlate",
            requires: ["VehicleVehicleModelSpelt", "VehicleYearMade", "VehicleVIN", "VehicleLicensePlate"],
            template: `
                <span ng-bind="item.VehicleVehicleModelSpelt"></span>
                <br/>
                <span ng-bind="item.VehicleYearMade"></span>
                <br/>
                <span ng-bind="item.VehicleVIN"></span>
                <br/>
                <span ng-bind="item.VehicleLicensePlate"></span>
            `,
            type: "Edm.String",
        }, {
            displayText: "Пользователь, Продавец, Контрагент",
            inlineFilter: "EmployeeName",
            requires: ["EmployeeName", "EmployeeIntermediateSellerName", "EmployeePointOfSaleName"],
            template: `
                <span ng-bind="item.EmployeeName"></span>
                <br/>
                <span ng-bind="item.EmployeePointOfSaleName"></span>
                <br/>
                <span class="text-muted" ng-bind="item.EmployeeIntermediateSellerName"></span>
            `,
            type: "Edm.String",
        }, {
            displayText: "Марка/Модель ТС",
            name: "VehicleVehicleModelSpelt",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Год выпуска ТС",
            name: "VehicleYearMade",
            type: "Edm.Int32",
            visible: false,
        }, {
            displayText: "VIN",
            name: "VehicleVIN",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Гос.номер ТС",
            name: "VehicleLicensePlate",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Продавец",
            name: "EmployeePointOfSaleName",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Контрагентского договора",
            name: "EmployeeIntermediateSellerName",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Код статуса договора",
            name: "StatusCode",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Пользователь",
            name: "EmployeeName",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Вид оплаты",
            name: "PaymentKindName",
            type: "Edm.String",
            visible: false,
        }, {
            displayText: "Id-договора",
            name: "Id",
            type: "Edm.Int32",
            visible: false,
        }, {
            displayText: "Серия и номер полиса",
            name: "PolicyFullValue",
            type: "Edm.String",
            visible: false,
        }];
        super.$onInit();
    }
}
